module.exports = __webpack_public_path__ + "assets/img/jpxl-title.3b99a462.png";